import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ingo-mobile-app-modal',
  styleUrls: ['mobile-app-modal.component.scss'],
  templateUrl: './mobile-app-modal.component.html'
})
export class MobileAppModalComponent {

  @Output() onOpenApp: EventEmitter<string> = new EventEmitter();
  @Output() onDismiss: EventEmitter<void> = new EventEmitter();
  @Output() onStopShowing: EventEmitter<void> = new EventEmitter();

  stopShowing: boolean = false;

  openApp(): void {
    if (this.stopShowing) {
      this.stopShowingThisModal();
    }
    this.onOpenApp.emit();
  }

  dismiss(): void {
    if (this.stopShowing) {
      this.stopShowingThisModal();
    }
    this.onDismiss.emit();
  }

  private stopShowingThisModal() {
    this.onStopShowing.emit();
  }
}
